import { TriangleAlert } from '@/components/icons';
import { errorMessage } from '@/lib/api';
import { Button } from './Button';

export function ErrorNotice({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center gap-3 rounded-panel bg-danger/10 p-4 text-sm text-danger ring-1 ring-danger/30"
    >
      <TriangleAlert className="size-5 shrink-0" />
      <span className="flex-1">{errorMessage(error)}</span>
      {onRetry && (
        <Button size="sm" variant="secondary" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}
